import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { FIREBASE_API } from 'src/config-global';

// Your web app's Firebase configuration
/*
    apiKey: "AIzaSyCOBtS_btljuX6M-W3BwZoJMZHys5mREQI",
    authDomain: "remassis-41151.firebaseapp.com",
    databaseURL: "https://remassis-41151.firebaseio.com",
    projectId: "remassis-41151",
    storageBucket: "remassis-41151.appspot.com",
    messagingSenderId: "597284598955",
    appId: "1:597284598955:web:031d7e1940fb5a9cbaf3ee",
    measurementId: "G-Z2JGY74DCV"
*/
// Initialize Firebase
const app = initializeApp(FIREBASE_API);

// Initialize Firebase services
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app; 